/**
 * 공지사항 관리 API
 */
import { apiClient } from "@/shared/api/client";
import { getItem } from "@/shared/utils/storage";
import {
    GetNoticeListResponseDto,
    GetNoticeDetailResponseDto,
    CreateNoticeRequestDto,
    UpdateNoticeRequestDto,
    NoticeResponseDto
} from "../types/notice.types";

const BASE_PATH = '/api/v1/portal/notice';

export const noticeApi = {
    /**
     * 공지사항 목록 조회
     */
    getNoticeList: async (): Promise<GetNoticeListResponseDto> => {
        const response = await apiClient.get<GetNoticeListResponseDto>(`${BASE_PATH}/list`);
        return response.data;
    },

    /**
     * 공지사항 등록
     */
    createNotice: async (request: CreateNoticeRequestDto): Promise<NoticeResponseDto> => {
        const insUser = getItem<string>('USER_ID');
        const requestWithUser = { ...request, insUser: insUser || '' };
        const response = await apiClient.post<NoticeResponseDto>(`${BASE_PATH}/create`, requestWithUser);
        return response.data;
    },

    /**
     * 공지사항 수정
     */
    updateNotice: async (request: UpdateNoticeRequestDto): Promise<NoticeResponseDto> => {
        const updUser = getItem<string>('USER_ID');
        const requestWithUser = { ...request, updUser: updUser || '' };
        const response = await apiClient.post<NoticeResponseDto>(`${BASE_PATH}/update`, requestWithUser);
        return response.data;
    },

    /**
     * 공지사항 삭제
     */
    deleteNotice: async (noticeId: number): Promise<NoticeResponseDto> => {
        const response = await apiClient.delete<NoticeResponseDto>(`${BASE_PATH}/${noticeId}`);
        return response.data;
    },

    /**
     * 읽지 않은 팝업 공지 조회 (협력사용)
     */
    getUnreadPopupNotices: async (): Promise<GetNoticeListResponseDto> => {
        const response = await apiClient.get<GetNoticeListResponseDto>(`${BASE_PATH}/popup`);
        return response.data;
    }
};
